module.exports = __webpack_public_path__ + "img/img02.5b6c7de5.png";